module.exports = __webpack_public_path__ + "svg/ServiceBox.8652981.svg";